import { useCallback, useMemo, useState } from 'react'

import { Banner, List } from 'slab'

import { parseError } from './utils'

export function useAPIErrorBanner ({
  fallbackMessage,
}: {
  fallbackMessage: string;
}) {
  const [error, _setError] = useState<{
    message: string;
    errors?: string[];
  } | null>(null)

  const errorBanner = useMemo(() => {
    if (!error) return null

    return (
      <Banner title={error.message} type='critical' onDismiss={() => _setError(null)}>
        {error.errors && (
          <List>
            {error.errors.map((error) => (
              <List.Item key={error}>{error}</List.Item>
            ))}
          </List>
        )}
      </Banner>
    )
  }, [error])

  const setError = useCallback((error: unknown) => {
    _setError(parseError(error, fallbackMessage))
  }, [])

  return {
    error,
    errorBanner,
    setError,
  }
}
